<ng-template #content let-modal>
  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">{{ title }}</h4>
    <button
      type="button"
      class="close"
      aria-label="Close"
      (click)="modal.dismiss('Cross click')"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <form class="formGroup container {{ locatorClass }}">
      <div class="mb-3" *ngFor="let item of formLabelAndKeyArray">
        <div class="row shortRow">
          <div class="itemContainer col" *ngIf="item.type == 'text'">
            <div class="seachLabel inputLabelContainer">
              <div class="inputLabel">
                <label id="{{ item.label }}">{{ item.label }}</label>
              </div>
            </div>
            <div class="inputContainer">
              <input
                *ngIf="item.maxlength"
                class="inputSearch"
                type="{{ item.type }}"
                [(ngModel)]="item.value"
                name="{{ item.key }}"
                id="{{ item.key }}"
                [required]="item.required"
                [readonly]="item.readonly"
                maxlength="{{ item.maxlength }}"
              />
              <input
                *ngIf="!item.maxlength"
                class="inputSearch"
                type="{{ item.type }}"
                [(ngModel)]="item.value"
                name="{{ item.key }}"
                id="{{ item.key }}"
                [required]="item.required"
                [readonly]="item.readonly"
              />
              <div *ngIf="item.required" class="supIndex">*</div>
            </div>
          </div>
        </div>
        <div class="row shortRow">
          <div class="itemContainer col" *ngIf="item.type == 'checkbox'">
            <div class="seachLabel inputLabelContainer">
              <div class="inputLabel">
                <label id="{{ item.label }}">{{ item.label }}</label>
              </div>
            </div>
            <div class="inputContainer">
              <input
                type="checkbox"
                class="inputSearch"
                [required]="item.required"
                [checked]="item.value"
                (click)="checkElement(item)"
              />
              <div *ngIf="item.required" class="supIndex">*</div>
            </div>
          </div>
        </div>
        <div class="row shortRow">
          <div
            class="itemContainer col adjustHeight adjustHeightContainerPC"
            *ngIf="item.type == 'text-area'"
          >
            <div class="seachLabel inputLabelContainer adjustHeight">
              <div class="inputLabel">
                <label id="{{ item.label }}">{{ item.label }}</label>
              </div>
            </div>
            <div class="adjustHeightContainerPC inputContainer">
              <textarea
                class="inputSearch adjustHeightPC"
                [required]="item.required"
                [(ngModel)]="item.value"
                [readonly]="item.readonly"
                name="{{ item.key }}"
                id="{{ item.key }}"
                maxlength="{{ item.maxlength ? item.maxlength : 500 }}"
                (input)="autoExpand($event)"
              ></textarea>
              <div *ngIf="item.required" class="supIndex">*</div>
            </div>
          </div>
        </div>
        <div class="row shortRow">
          <div class="itemContainer col" *ngIf="item.type == 'list'">
            <div class="seachLabel inputLabelContainer">
              <div class="inputLabel">
                <label id="{{ item.label }}">{{ item.label }}</label>
              </div>
            </div>
            <div class="inputContainer selectorWidth">
              <app-input-selector-with-search
                [list]="item.list"
                [fields]="item.key"
                [id]="item.key[0]"
                [item]="getInitialValue(item)"
                (sendValue)="elementSelectOfList($event, item)"
              ></app-input-selector-with-search>
              <div *ngIf="item.required" class="supIndex">*</div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
  <div class="modal-footer">
    <button type="submit" class="btn" (click)="onSave()">
      {{ "commons.ok" | translate }}
    </button>
  </div>
</ng-template>

<swal
  #confirmSwal
  html="{{ confirmMessage }}"
  icon="warning"
  [showCancelButton]="true"
  [swalOptions]="{
    confirmButtonText: 'Aceptar',
    cancelButtonText: 'Cancelar',
    allowEscapeKey: false,
    allowOutsideClick: false
  }"
  [focusCancel]="true"
>
</swal>
